function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-30.000000, -106.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Navigation"
}, /*#__PURE__*/React.createElement("g", {
  id: "Cups,-dirty-dishes",
  transform: "translate(30.000000, 106.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.97225,16.6665 C13.18375,16.39625 13.379,16.119 13.55775,15.83325 L15.83325,15.83325 C17.2135,15.83325 18.33325,14.7135 18.33325,13.33325 C18.33325,11.953 17.2135,10.83325 15.83325,10.83325 L3.33325,10.83325 C3.33325,12.898 4.013,14.96 5.36125,16.6665 L0,16.6665 L0,18.33325 L1.66675,18.33325 L2.12725,19.2545 C2.33225,19.66475 2.876,19.99975 3.33325,19.99975 L16.6665,19.99975 C17.1255,19.99975 17.6675,19.6645 17.8725,19.2545 L18.333,18.33325 L20,18.33325 L20,16.6665 L12.97225,16.6665 Z M14.84675,12.5 L15.833,12.5 C16.294,12.5 16.6665,12.87425 16.6665,13.33325 C16.6665,13.79225 16.294,14.1665 15.833,14.1665 L14.38475,14.1665 C14.58975,13.623 14.746,13.0665 14.84675,12.5 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6665,0.00025 L4.16675,0.00025 C4.16675,0.9475 4.314,1.89225 4.59725,2.8045 L16.90575,4.97575 C18.17175,4.85475 19.1665,3.799 19.1665,2.5005 C19.1665,1.11975 18.047,0.00025 16.6665,0.00025 Z M16.6665,3.3335 L15.21775,3.3335 C15.42275,2.78975 15.579,2.23325 15.68025,1.66675 L16.6665,1.66675 C17.127,1.66675 17.5,2.04125 17.5,2.50025 C17.5,2.95925 17.127,3.3335 16.6665,3.3335 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.27875,9.16675 L14.2755,9.16675 C14.74275,8.28675 15.07325,7.34625 15.24425,6.3755 L3.755,4.349 C3.755,4.349 3.755,4.349 3.755,4.34975 L2.93475,4.205 C1.5755,3.96475 0.2785,4.873 0.03925,6.232 C-0.2015,7.59175 0.70675,8.88825 2.06725,9.129 L2.27875,9.16675 Z M1.67975,6.522 C1.7595,6.07025 2.1925,5.76675 2.64475,5.8465 L3.6165,6.0175 C3.61825,6.593 3.675,7.16825 3.7825,7.7395 L2.35525,7.48725 C1.90275,7.40725 1.6,6.97425 1.67975,6.522 Z",
  id: "Shape"
})))));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.d0ec2acc.svg";
export { ForwardRef as ReactComponent };